import { defineStore } from "pinia";
import Notification from "@/classes/Notification.ts";

export const useNotifications = defineStore("Notifications", {
  state: () => ({
    stack: [] as Notification[],
  }),

  getters: {
    current(state): Notification | undefined {
      // `.reverse()` reversed the stored array in place on every read, flipping the order.
      return state.stack[state.stack.length - 1];
    },
  },

  actions: {
    push(notification: Notification) {
      this.stack.push(notification);
    },

    pop(notification: Notification) {
      notification.dismiss();

      this.stack = this.stack.filter((a: Notification) => a.id !== notification.id);
    },
  },
});
